export default __webpack_public_path__ + "static/media/compress-alt.b15a146e.svg";